import axios from 'axios'

const REF_DATA_API = process.env.VUE_APP_REFDATA_API

function fetchReferenceData() {
  return axios.get(`${REF_DATA_API}/si-reference-data.json`)
}

export default { fetchReferenceData }
